import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import defaultTexts from '../../../texts/texts'
import AdminUiWrapper from './AdminUiWrapper'
import CustomerUiWrapper from './CustomerUiWrapper'

const UserInterfaceServicesWrapper = (props) => {
  const { services, supportedServiceConfigs, showAdminUI, showCustomerUI, setFetchServices } = props
  const theme = useTheme()

  const [adminUiService, setAdminUiService] = useState(null)
  const [customerUiService, setCustomerUiService] = useState(null)

  const labelStyle = {
    color: theme.palette.vodka,
    fontSize: '18px',
    fontWeight: '500',
  }

  const labelArrowStyle = {
    color: theme.palette.oxfordBlue,
  }
  
  useEffect(() => {
    if (services && services.length > 0) {
      const admin_ui_service = services.find(item => item.service === 'custom_admin_ui')
      const customer_ui_service = services.find(item => item.service === 'custom_client_ui')
      setAdminUiService(admin_ui_service ? admin_ui_service : null)
      setCustomerUiService(customer_ui_service ? customer_ui_service : null)
    } else {
      setAdminUiService(null)
      setCustomerUiService(null)
    }
  }, [services])

  return (
    <>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='flex-start'
        spacing={3}
        sx={{
          padding: '20px 0px 40px 20px',
        }}
      >
        <Box sx={labelStyle}>{defaultTexts.configuration}</Box>
        <ArrowForwardIosIcon fontSize='small' sx={labelArrowStyle} />
        <Box sx={labelStyle}>{defaultTexts.userInterfaces}</Box>
      </Stack>
      
      <Box sx={{ padding: '0px 10px' }}>
        {
          showAdminUI &&
          <AdminUiWrapper
            adminUiService={adminUiService}
            setFetchServices={setFetchServices}
          />
        }
        
        {
          showCustomerUI &&
          <CustomerUiWrapper
            customerUiService={customerUiService}
            supportedServiceConfigs={supportedServiceConfigs}
            setFetchServices={setFetchServices}
          />
        }        
      </Box>      
    </>
  )
}

export default UserInterfaceServicesWrapper